import type {FC} from 'react';
import React from 'react';
import classNames from 'classnames';

import TimePicker from 'react-time-picker';

// eslint-disable-next-line no-restricted-syntax
import 'react-time-picker/dist/TimePicker.css';

import styles from './time-input.module.styl';

export type TimeInputProps = {
    timeFormat?: string,
    value?: string | Date,
    onChange?: (time: string) => void,
};

export const TimeInput: FC<TimeInputProps> = ({
    timeFormat,
    value,
    onChange,
}) => {
    // Extract format info directly from timeFormat string
    const hasAmPm = timeFormat ? /[aA]{1,2}/.test(timeFormat) : false;
    // Simple format: only HH:mm or hh:mm aa (no seconds)
    const timePickerFormat = hasAmPm ? 'hh:mm aa' : 'HH:mm';

    const handleChange = (newValue: Date | string | null) => {
        if (onChange && newValue) {

            onChange(String(newValue));
        }
    };

    const wrapperClassNames = classNames(styles.timeInputWrapper);

    return (
        <TimePicker
            className={wrapperClassNames}
            onChange={handleChange}
            value={value}
            disableClock={true}
            format={timePickerFormat}
            clearIcon={null}
            clockIcon={null}
        />
    );
};

TimeInput.displayName = 'TimeInput';
